/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
/**
 * a Stack specially for Undo/Redo handling
 */
export class UndoStack {
    constructor(maxElements = 100, reduceCount = 50) {
        this._stack = new Array();
        this._currentIdx = -1;
        this._maxElems = (maxElements > 1) ? maxElements : 2;
        this._reduceCount = (this._maxElems > reduceCount) ? reduceCount : this._maxElems - 1;
    }
    push(item) {
        if (this._maxElems > (this._currentIdx + 1)) {
            this._currentIdx++;
            this._stack.splice(this._currentIdx);
            this._stack.push(item);
        }
        else {
            this._handleUndoLimit(item);
        }
    }
    undo() {
        if (this._stack.length > 0) {
            const preIdx = this.canUndo() ? this._currentIdx - 1 : this._currentIdx;
            const item = this._stack[preIdx];
            this._currentIdx = preIdx;
            return item;
        }
        else {
            // tslint:disable-next-line:no-console
            console.error('UndoStack not initialized, please push at lease one element to the stack');
            return undefined;
        }
    }
    redo() {
        if (this._stack.length > 0) {
            const nextIdx = this.canRedo() ? this._currentIdx + 1 : this._currentIdx;
            const item = this._stack[nextIdx];
            this._currentIdx = nextIdx;
            return item;
        }
        else {
            // tslint:disable-next-line:no-console
            console.error('UndoStack not initialized, please push at lease one element to the stack');
            return undefined;
        }
    }
    canUndo() {
        return this._currentIdx > 0;
    }
    canRedo() {
        return (this._stack.length > (this._currentIdx + 1));
    }
    _clearInception(count) {
        this._stack.splice(0, count);
        this._currentIdx = this._currentIdx - count;
    }
    _handleUndoLimit(item) {
        // tslint:disable-next-line:no-console
        console.warn('undo limit reached, ' + this._reduceCount + ' first elements removed');
        this._clearInception(this._reduceCount);
        this.push(item);
    }
}
//# sourceMappingURL=UndoStack.js.map